import * as React from "react";
import { forwardRef } from "react";
const SvgOpensidebar = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M0 0h20v20H0z", className: "sbcda701fc0dd66c43709468d4a921c83__a" }), /* @__PURE__ */ React.createElement("path", { d: "M0 18v-1.778h20V18Zm0-7.111V9.111h15v1.778Zm0-7.111V2h20v1.778Z", className: "sbcda701fc0dd66c43709468d4a921c83__b" }));
const ForwardRef = forwardRef(SvgOpensidebar);
export { ForwardRef as ReactComponent };
